import React from "react";
import styled from "styled-components/macro";
import { SectionSubTitle } from "theme/GlobalElements";
import { Assets } from "assets/Assets";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay, Pagination, Navigation } from "swiper";
import { device } from "theme/Breakpoints";

SwiperCore.use([Autoplay, Pagination, Navigation]);

interface OurClientsProps {}

const OurClients: React.FC<OurClientsProps> = ({}) => {
  return (
    <OurClientsContainer>
      <h3>
        Нашите клиенти
        <p className="caption">част от компаниите с които сме работили</p>
      </h3>
      <Companies>
        <Swiper
          loop
          pagination
          slidesPerView="auto"
          spaceBetween={12}
          breakpoints={{
            1: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 3,
            },
            1366: {
              slidesPerView: 4,
            },
          }}
        >
          {Object.keys(Assets.About.companies).map((img) => {
            // @ts-ignore
            const value = Assets.About.companies[img];
            return (
              <SwiperSlide
                key={img}
                style={{
                  width: "auto",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <CompanyImgContainer
                  style={{ backgroundImage: `url(${value})` }}
                />
              </SwiperSlide>
            );
          })}
        </Swiper>
      </Companies>
    </OurClientsContainer>
  );
};

const OurClientsContainer = styled.div`
  padding: 0 10px;

  .swiper-button-prev {
    display: none;
  }

  .swiper-button-next {
    color: black;
  }

  @media only screen and (${device.laptop}) {
    padding: 0 20px;
  }
`;

const Companies = styled.div`
  margin: 20px 0;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
`;

const CompanyImgContainer = styled.div`
  height: 200px;
  width: 250px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;

  margin-bottom: 50px;
`;

const CompanyImg = styled.img`
  max-height: 100%;
`;
export default OurClients;
